// extracted by mini-css-extract-plugin
export default {"content":"UserPage_content__AJAeA"};